/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useTranslation } from 'react-i18next';
import Style from './style';
import Widget from '../../widget';
import { placeholder } from '../../helpers';
import ComponentWithFocus from '../../components/component-with-focus';
import useSubjectDetails from './hook';

import 'leaflet/dist/leaflet.css';
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import "leaflet.markercluster/dist/leaflet.markercluster";
import { LoadingOutlined } from '@ant-design/icons';

export default function SubjectDetails({
  data = {},
  namespace = null,
  getOption = () => { },
  isOwnData,
  loading,
  sources,
}) {
  const { t } = useTranslation();
  const {
    actions,
    container,
    primaryLocation,
  } = useSubjectDetails({ data, loading });

  return (
    <Widget
      title={t('Subject Details')}
      header={(
        <div className="flex justify-content-end flex-1">
          {!isOwnData ? null
            // namespacesWithSA.includes(namespace)
            // ? loading ? (
            //   <div>
            //     <LoadingOutlined className="loading-icon" style={{ color: '#1570EF' }} />
            //   </div>
            // ) : renderSelfAvailabilityTag(t, data.selfAssessment)
            // : null
            : null}
        </div>
      )}
    >
      <Style>
        <ComponentWithFocus className="flex-1 flex" actions={actions}>
          {loading ? (
            <div className="map">
              <LoadingOutlined className="loading-icon" />
            </div>
          ) : <div className="map" ref={container} />}
        </ComponentWithFocus>
        <div className="bottom-section">
          <div className="default-section">
            <label className="title">{t('Primary Location')}</label>
            <label className="value">
              {loading ? (
                <LoadingOutlined className="loading-icon" />
              ) : primaryLocation}
            </label>
          </div>
          <div className="default-section">
            <label className="title">{t('Legal Form')}</label>
            <label className="value">
              {loading ? (
                <LoadingOutlined className="loading-icon" />
              ) : data.legal ? getOption('stakeholderSubCategoriesOptions', data.legal) : placeholder}
            </label>
          </div>
          {!isOwnData && (
            <div className="default-section">
              <label className="title">{t('Information Sources')}</label>
              <label className="value">
                {loading ? (
                  <LoadingOutlined className="loading-icon" />
                ) : sources}
              </label>
            </div>
          )}
        </div>
      </Style>
    </Widget>
  )
}
